module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp2_7042.b47bbcc7.png";